// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox-rounded_container__3TJAo","label":"checkbox-rounded_label__2xHmU","checkmark":"checkbox-rounded_checkmark__2KhuX","checked":"checkbox-rounded_checked__3OqTy"};